import { useAtom } from 'jotai';
import { createDietitianAttachmentConsultationMutationAtom } from '@/features/fileUpload/model/createDietitianUploadConsultationMutationAtom';

export const useCreateDietitianUploadConsultation = () => {
    const [{ mutate, status, reset, error }] = useAtom(
        createDietitianAttachmentConsultationMutationAtom,
    );

    return {
        mutate,
        status,
        reset,
        errorMessage: error instanceof Error ? error.message : null,
    };
};
